
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[region]",
      function () {
        return require("private-next-pages/destinations/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[region]"])
      });
    }
  